import axios from 'axios';
import {
  AdminBrandsApiFactory,
  AdminBundleAcquisitionPricesApiFactory,
  AdminBundlePricesApiFactory,
  AdminBundlesApiFactory,
  AdminCategoriesApiFactory,
  AdminCountriesApiFactory,
  AdminExternalProductsApiFactory,
  AdminMaterialsApiFactory,
  AdminPriceRefreshRequestsApiFactory,
  AdminProductsApiFactory,
  AdminProductVariantsApiFactory,
  AdminPropertyValuesApiFactory,
  AdminSalesChannelsApiFactory,
  AdminTagsApiFactory,
  AdminTeliaFinanceProductsApiFactory,
  Configuration,
  LocalesApiFactory,
  PropertiesApiFactory,
  SalesChannelItemsApiFactory,
} from '@cdaas/api-clients/dist/product-service-openapi';

const productServiceConfig = new Configuration({ basePath: process.env.REACT_APP_PRODUCT_SERVICE_URL });

export const productServiceAdminBrandsClient = AdminBrandsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminBundleAcquisitionPricesClient = AdminBundleAcquisitionPricesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminBundlePricesClient = AdminBundlePricesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminBundlesClient = AdminBundlesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminCategoriesClient = AdminCategoriesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminExternalProductsClient = AdminExternalProductsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminMaterialsClient = AdminMaterialsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminPriceRefreshRequestsClient = AdminPriceRefreshRequestsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminProductsClient = AdminProductsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminProductVariantsClient = AdminProductVariantsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminPropertyValuesClient = AdminPropertyValuesApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminSalesChannelsClient = AdminSalesChannelsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminTagsClient = AdminTagsApiFactory(productServiceConfig, undefined, axios);
export const productServiceAdminTeliaFinanceProductsClient = AdminTeliaFinanceProductsApiFactory(productServiceConfig, undefined, axios);
export const productServiceCountriesClient = AdminCountriesApiFactory(productServiceConfig, undefined, axios);
export const productServiceLocalesClient = LocalesApiFactory(productServiceConfig, undefined, axios);
export const productServicePropertiesClient = PropertiesApiFactory(productServiceConfig, undefined, axios);
export const productServiceSalesChannelItemsClient = SalesChannelItemsApiFactory(productServiceConfig, undefined, axios);
